import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@alphabait/ui' // card'
import { ReactNode } from 'react'
import { ChartLoadingState } from './chart-loading-state'
import { ChartErrorState } from './chart-error-state'
import { t } from 'i18next'

interface ChartWrapperProps {
  title: ReactNode
  description?: string
  children: ReactNode
  className?: string
  contentClassName?: string
  isLoading?: boolean
  error?: string | Error
  loadingMessage?: string
}

export function ChartWrapper({
  title,
  description,
  children,
  className = '',
  contentClassName = '',
  isLoading = false,
  error,
  loadingMessage,
}: ChartWrapperProps) {
  return (
    <Card className={`h-96 flex flex-col ${className}`}>
      <CardHeader>
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent
        className={`flex-1 flex w-full min-h-0 overflow-y-auto ${
          contentClassName || 'items-center justify-center'
        }`}
      >
        {isLoading ? (
          <ChartLoadingState message={loadingMessage} />
        ) : error ? (
          <ChartErrorState
            message={t('dashboard.charts.failed')}
            error={typeof error === 'string' ? error : error.message}
          />
        ) : (
          children
        )}
      </CardContent>
    </Card>
  )
}
